interface ScaSignature {
  displayName: string
  date: string
  ip: string
}

interface Props {
  sca: ScaSignature
}

function DigitalSignature({ sca }: Props) {
  return (
    <>
      <br />
      <br />
      <p>{`Digitally signed by ${sca.displayName} on ${sca.date} on machine ${sca.ip}`}</p>
    </>
  )
}

export default DigitalSignature